import { aed } from "@/lib/format";
import {
  buildReportDocument,
  openReportPrint,
  periodMeta,
  resolveReportLetterhead,
  escapeReportHtml,
} from "@/lib/reportPrintShell";

function cell(value) {
  return value ? aed(value) : "";
}

export async function printLedgerReport(report, title = "Ledger Report", options = {}) {
  if (!report?.account) return false;
  const withBranch = { ...report, branch_id: report.branch_id ?? options.branchId, all_branches: options.allBranches };

  const rows = (withBranch.entries || [])
    .map(
      (e) => `
      <tr>
        <td>${e.voucher_date || ""}</td>
        <td class="mono">${e.voucher_number || ""}</td>
        <td>${e.voucher_type || ""}</td>
        <td>${e.narration || e.party_name || ""}</td>
        <td class="num">${cell(e.debit)}</td>
        <td class="num">${cell(e.credit)}</td>
        <td class="num">${aed(e.balance)}</td>
      </tr>`,
    )
    .join("");

  const company = await resolveReportLetterhead({ branchId: withBranch.branch_id, allBranches: withBranch.all_branches });
  const html = buildReportDocument({
    title,
    company,
    metaHtml: `<div><strong>Account:</strong> ${escapeReportHtml(withBranch.account.code)} — ${escapeReportHtml(withBranch.account.name)}</div>
    ${periodMeta(withBranch)}
    <div><strong>Opening Balance:</strong> ${aed(withBranch.opening_balance)}</div>`,
    bodyHtml: `<table>
    <thead>
      <tr>
        <th>Date</th><th>Voucher</th><th>Type</th><th>Particulars</th>
        <th>Debit</th><th>Credit</th><th>Balance</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td colspan="4"><em>Opening balance</em></td>
        <td class="num"></td><td class="num"></td>
        <td class="num">${aed(withBranch.opening_balance)}</td>
      </tr>
      ${rows}
    </tbody>
    <tfoot>
      <tr>
        <th colspan="4">Closing balance</th>
        <th class="num">${aed(withBranch.total_debit)}</th>
        <th class="num">${aed(withBranch.total_credit)}</th>
        <th class="num">${aed(withBranch.closing_balance)}</th>
      </tr>
    </tfoot>
  </table>`,
  });

  return openReportPrint(html);
}
